import { CircularProgress, Tooltip } from "@mui/material";
import React, { memo } from "react";
import { useSelector } from "react-redux";
import LineAreaChartNivo from "common/components/chartNivo/oldChart/lineAreaChart";
import { ResponsiveDivChart } from "styledComponents/component";
import { cumulativeReturnAnalysis } from "../nlg/nlg";
import Description from "../description";
import { Info } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { useTheme, useMediaQuery } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  tooltip: {
    maxWidth: 250,
    fontSize: 12,
    padding: 5,
  },
}));
const ReturnBox = memo(({ tip }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const reducerportfolio = useSelector(
    (state) => state.select_portfolio_history_reducer,
  );
  const loadingReducer = useSelector((state) => state.loading);

  const handleClassChartParent = () => {
    let length = reducerportfolio.data.length;
    if (length > 30 && length < 80) {
      return "w-[1100px] h-[400px]";
    }
    if (length > 80 && length < 200) {
      return "w-[2000px] h-[400px]";
    }
    if (length > 300) {
      return "w-[6300px] h-[400px]";
    }
    if (length > 200) {
      return "w-[4300px] h-[400px]";
    } else {
      return "w-[500px] lg:w-full h-[400px]";
    }
  };

  const analysis = cumulativeReturnAnalysis(reducerportfolio.data);

  return (
    <>
      <div
        className="flex justify-between items-center"
        style={{ width: "max-content" }}
      >
        {/* <video width="750" height="500" controls >
          <source src="/media/video/Systematic Vs Unsystematic Risk 2.m4v" type="video/m4v" />
        </video> */}
        <h1 className="pr-3 mb-3 mt-2 mx-2">بازدهی تجمعی</h1>
        <Tooltip
          title={
            <p className="p-2 m-0">
              {tip}

              {/* <video width="300" height="200" controls autoPlay>
                <source src="/media/video/Systematic Vs Unsystematic Risk 2.mp4" type="video/mp4" />
              </video> */}
            </p>
          }
          placement={isMobile ? "bottom" : "left"}
          arrow
          classes={{ tooltip: classes.tooltip }}
          enterTouchDelay={1}
        >
          {/* <Info
           style={{
            color: "rgb(13, 158, 13)",
            float: "left",
            fontSize: "1.3rem",
          }}
          
          /> */}
          <img src="/media/image/Group 12485.png" />
        </Tooltip>
      </div>

      <div className="grid grid-cols-12">
        <div className="col-span-12 lg:col-span-4">
          <div className="text-sm text-gray-700 p-5">
            نمودار پیش رو، روند رشد مجموع دارایی شما اعم از سرمایه نقد، سبد سهام
            و اوراق بدهی را نمایش می‌دهد.
          </div>
          <Description analysis={analysis} />
        </div>
        <div className="col-span-12 lg:col-span-8">
          {/* <SummaryTable reducerselectKey={reducerselectKey} /> */}
          {loadingReducer.loading ? (
            <div className="h-full w-full flex justify-center items-center">
              <CircularProgress />
            </div>
          ) : (
            <ResponsiveDivChart>
              <div
                className={handleClassChartParent()}
                style={{ direction: "ltr" }}
              >
                <LineAreaChartNivo
                  reducerportfolio={reducerportfolio}
                  daily_return
                />
              </div>
            </ResponsiveDivChart>
          )}
        </div>
      </div>
    </>
  );
});

export default ReturnBox;
